import {getDigits} from '@yandex-delivery/core/phones/utils'
import {pipe} from '@yandex-delivery/utils'
import {type ReactElement} from 'react'
import {useWatch} from 'react-hook-form'

import {useConfigContext} from '../../../contexts'
import {type InputType, TextInput} from '../TextInput'

export const PhoneInput = (props: InputType): ReactElement => {
  const {name} = props
  const phone = useWatch({name})

  const {normalizePhone, getPhoneMask} = useConfigContext()

  const normalizePhoneInput = (input: string): string => {
    return pipe(input, getDigits, addCorrectPrefix, normalizePhone, removeLeadingPlus)
  }

  return (
    <TextInput
      {...props}
      autoComplete="tel"
      debounceDelay={200}
      inputMode="tel"
      inputTransformationFunction={normalizePhoneInput}
      mask={getPhoneMask?.(phone)}
      type="tel"
    />
  )
}

function removeLeadingPlus(phone: string): string {
  if (phone[0] === '+') {
    return phone.substring(1)
  }
  return phone
}

function addCorrectPrefix(phone: string): string {
  if (!['7', '8', ''].includes(phone.substring(0, 1))) {
    return '7' + phone
  }

  return phone
}
